export default "__VITE_ASSET__WcU2Deu1__"